import { render, staticRenderFns } from "./KezInformationModal.vue?vue&type=template&id=32a869db&"
import script from "./KezInformationModal.vue?vue&type=script&lang=js&"
export * from "./KezInformationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "KezInformationModal.vue"
export default component.exports